// src/store/slices/user/userSlice.ts

import { createSlice } from '@reduxjs/toolkit';

import { initialUserState } from '@/types/UserState';
import { fetchNotificationsThunk } from '@/store/thunks/user/fetchNotificationsThunk';
import { getMeThunk } from '@/store/thunks/user/getMeThunk';
import { extractThunkError } from '@/store/utils';

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ME
      .addCase(getMeThunk.pending, (state) => {
        state.loadingUser = true;
        state.fieldErrors = {};
      })
      .addCase(getMeThunk.fulfilled, (state, action) => {
        state.loadingUser = false;
        state.user = action.payload;
      })
      .addCase(getMeThunk.rejected, (state, action) => {
        state.loadingUser = false;
        state.user = null;
        state.fieldErrors = extractThunkError(action.payload).fieldErrors;
      })
      // FETCH NOTIFICATIONS
      .addCase(fetchNotificationsThunk.pending, (state) => {
        state.loadingNotifications = true;
      })
      .addCase(fetchNotificationsThunk.fulfilled, (state, action) => {
        state.loadingNotifications = false;
        state.notifications = action.payload;
      })
      .addCase(fetchNotificationsThunk.rejected, (state) => {
        state.loadingNotifications = false;
      })
  },
});

export default userSlice.reducer;
